import React, { useContext } from 'react'
import { Flex, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'
import BootstrapDataContext from '../../../context/BootstrapDataContext'

type FlexContainerProps = {
  className: string
  children: React.ReactNode
}

const FlexContainer = ({
  className,
  children,
  ...rest
}: FlexContainerProps & Record<string, unknown>) => {
  const { isMobile = false } = useContext(BootstrapDataContext)
  return (
    <Flex
      className={className}
      isMobile={isMobile}
      borderRadius="lg"
      m={0}
      role="option"
      width={1}
      {...rest}
    >
      {children}
    </Flex>
  )
}

const DropdownItem = styled(FlexContainer)`
  background-color: ${props =>
    props.isHighlighted ? getPaletteColor('primary.base') : null};
  color: ${props =>
    props.isHighlighted ? getPaletteColor('text.lightest') : null};
  svg {
    color: ${props =>
      props.isHighlighted ? getPaletteColor('text.lightest') : null};
  }

  cursor: pointer;
  align-items: center;

  &:hover {
    background-color: ${props =>
      props.isMobile ? null : getPaletteColor('primary.base')};
    color: ${props =>
      props.isMobile ? null : getPaletteColor('text.lightest')};
    svg {
      color: ${props =>
        props.isMobile ? null : getPaletteColor('text.lightest')};
    }
  }

  &:focus {
    background-color: ${getPaletteColor('primary.base')};
    color: ${getPaletteColor('text.lightest')};
    svg {
      color: ${getPaletteColor('text.lightest')};
    }
  }
`

export default DropdownItem
